module.exports = __webpack_public_path__ + "static/media/ic-notification-empty.41827d79.svg";